import moment from 'moment';

/**
 * Normalize holiday dates from API (ISO string, Jackson [y,m,d], or Date) to YYYY-MM-DD.
 * Jackson LocalDate arrays use 1-based month; moment arrays use 0-based.
 */
export const formatHolidayKey = (date) => {
  if (date == null || date === '') return null;
  if (typeof date === 'string') {
    const parsed = moment(date);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
  }
  if (Array.isArray(date) && date.length >= 3) {
    const parsed = moment({
      year: date[0],
      month: date[1] - 1,
      day: date[2],
    });
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
  }
  if (typeof date === 'object' && date.year != null && date.monthValue != null) {
    const parsed = moment({
      year: date.year,
      month: date.monthValue - 1,
      day: date.dayOfMonth ?? date.day,
    });
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

export const toHolidaySet = (holidayList) => {
  const set = new Set();
  if (!Array.isArray(holidayList)) return set;
  holidayList.forEach((item) => {
    const key = formatHolidayKey(item?.date ?? item);
    if (key) set.add(key);
  });
  return set;
};

/** Normalize getHolidays / ErrorSwitchCase response into a holiday row array. */
export const extractHolidayRows = (holidayResponse) => {
  if (!holidayResponse || holidayResponse.isError) return [];
  if (Array.isArray(holidayResponse.data)) return holidayResponse.data;
  if (Array.isArray(holidayResponse.data?.data)) return holidayResponse.data.data;
  if (Array.isArray(holidayResponse)) return holidayResponse;
  return [];
};

/**
 * Inclusive working-day count: weekdays minus holidays.
 * start/end accept YYYY-MM-DD strings or Date/moment-parsable values.
 */
export const countWorkingDays = (start, end, holidaySet = new Set()) => {
  if (!start || !end) return 0;
  const current = moment(start, 'YYYY-MM-DD', true).isValid()
    ? moment(start, 'YYYY-MM-DD').startOf('day')
    : moment(start).startOf('day');
  const last = moment(end, 'YYYY-MM-DD', true).isValid()
    ? moment(end, 'YYYY-MM-DD').startOf('day')
    : moment(end).startOf('day');
  if (!current.isValid() || !last.isValid() || current.isAfter(last, 'day')) {
    return 0;
  }
  let count = 0;
  while (current.isSameOrBefore(last, 'day')) {
    const day = current.day();
    const key = current.format('YYYY-MM-DD');
    if (day !== 0 && day !== 6 && !holidaySet.has(key)) {
      count += 1;
    }
    current.add(1, 'day');
  }
  return count;
};
